import { render, staticRenderFns } from "./userInfo.vue?vue&type=template&id=33115a25&scoped=true&"
import script from "./userInfo.vue?vue&type=script&lang=ts&"
export * from "./userInfo.vue?vue&type=script&lang=ts&"
import style0 from "./userInfo.vue?vue&type=style&index=0&id=33115a25&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33115a25",
  null
  
)

export default component.exports